export default {
  state: {
    // TRTCcalling
    callStatus: 'idle', // 状态, idle, calling, connected
    // 是不是邀请者 Boolean
    isInviter: false,
    // 用户是否接听
    userAccept: false,
    // 通话类型, 1: 语音通话, 2: 视频通话
    callType: 2,
    // 设备列表
    devices: {
      micList: [],
      cameraList: [],
      currentMicrophone: {},
      currentCamera: {},
    },
    muteVideoUserIdList: [],
    muteAudioUserIdList: [],
    timLogin: false,
  },
  mutations: {
    // TRTCcalling
    updateCallStatus(state, callStatus) {
      state.callStatus = callStatus
    },
    updateIsInviter(state, isInviter) {
      state.isInviter = isInviter
    },
    updateCallType(state, callType) {
      state.callType = callType
    },
    userAccepted(state, userAccept) {
      state.userAccept = userAccept
    },
    updateDeviceList(state, updateDevices) {
      state.devices = updateDevices
    },
    updateMuteVideoUserIdList(state, userIdList) {
      state.muteVideoUserIdList = userIdList
    },
    updateMuteAudioUserIdList(state, userIdList) {
      state.muteAudioUserIdList = userIdList
    },
    updateTimLogin(state, timLogin) {
      state.timLogin = timLogin
    },
  },
}
